export const mergeHeaders = (...sources: (HeadersInit | undefined | null)[]): Headers => {
  const headers = new Headers();

  for (const source of sources) {
    if (!source) {
      continue;
    }

    if (source instanceof Headers) {
      // overcome TS issue with Headers type safety
      (source as unknown as string[]).forEach((value, key) => {
        headers.set(key as unknown as string, value);
      });
      continue;
    }

    if (Array.isArray(source)) {
      source.forEach(([ key, value ]) => {
        headers.set(key, value);
      });
      continue;
    }

    if (typeof source === 'object') {
      Object.entries(source).forEach(([ key, value ]) => {
        headers.set(key, value);
      });
    }
  }

  return headers;
};
